import type React from "react";
import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDesktop } from "@fortawesome/free-solid-svg-icons";

const MobileBanner = (): React.JSX.Element | null => {
  const [isMobile, setIsMobile] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();

    const dismissed = sessionStorage.getItem("mobileBannerDismissed");
    if (dismissed) {
      setIsDismissed(true);
    }

    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Lock body scroll when overlay is shown
  useEffect(() => {
    if (isMobile && !isDismissed) {
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
      document.body.style.height = "100%";
    } else {
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
      document.body.style.height = "";
    }

    return () => {
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
      document.body.style.height = "";
    };
  }, [isMobile, isDismissed]);

  const handleDismiss = () => {
    setIsDismissed(true);
    sessionStorage.setItem("mobileBannerDismissed", "true");
  };

  if (!isMobile || isDismissed) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: "100vw",
        minHeight: "100dvh",
        background: "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)",
        color: "white",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        zIndex: 9999,
        textAlign: "center",
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          background: "linear-gradient(135deg, #f59e0b 0%, #ea580c 100%)",
          borderRadius: "50%",
          width: "70px",
          height: "70px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "20px",
          flexShrink: 0,
        }}
      >
        <FontAwesomeIcon icon={faDesktop} style={{ fontSize: "28px" }} />
      </div>

      <h1 style={{
        fontSize: "22px",
        fontWeight: 700,
        marginBottom: "12px",
        lineHeight: 1.2,
      }}>
        Desktop Recommended
      </h1>

      <p style={{
        color: "#94a3b8",
        fontSize: "15px",
        marginBottom: "28px",
        maxWidth: "260px",
        lineHeight: 1.6,
      }}>
        Pokéraoke works best on desktop. For the full experience, please use a larger screen.
      </p>

      <button
        onClick={handleDismiss}
        style={{
          background: "linear-gradient(135deg, #f59e0b 0%, #ea580c 100%)",
          border: "none",
          borderRadius: "12px",
          color: "white",
          padding: "14px 28px",
          fontSize: "15px",
          fontWeight: 600,
          cursor: "pointer",
          touchAction: "manipulation",
          WebkitTapHighlightColor: "transparent",
        }}
        type="button"
      >
        Continue Anyway
      </button>
    </div>
  );
};

export default MobileBanner;
